
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as pdsTAdD3_S3FC4AgoXAojfEUYnY8hL38GOuJB9eWd2_aP4Meta } from "/vercel/path1/app/pages/pds.vue?macro=true";
import { default as about1yy_W_UuA8NOtDVpWlgeVMtEXWH1VIA3SOLelfaw9EkMeta } from "/vercel/path1/app/pages/about.vue?macro=true";
import { default as indexaKxhKqcT0mam5bL41UpyfOU4R4O3dFz94_Mrb5Jq7DkMeta } from "/vercel/path1/app/pages/index.vue?macro=true";
import { default as search8KjY8J4YCJiE44TmGEinSV1D4_SDzOPGmht37e6M3ggMeta } from "/vercel/path1/app/pages/search.vue?macro=true";
import { default as compare8QbVU71ZwawNDhFUkt7IZ8wO5CPOHSvKKIE7HQttAw8Meta } from "/vercel/path1/app/pages/compare.vue?macro=true";
import { default as privacy3_4_2DWeL0pXPGZTkNr_r_JGrofVszCZAYfN5nMYq6EMeta } from "/vercel/path1/app/pages/privacy.vue?macro=true";
import { default as settingsRjI6KdTPgUeu9KnQgm9Ka6vGor8HpmrE6e8qfQexNPkMeta } from "/vercel/path1/app/pages/settings.vue?macro=true";
import { default as _91org_93TNcydLYQ4dPceQtptPKUPzgYAbndNzs_9kPvFl_C2qkMeta } from "/vercel/path1/app/pages/org/[org].vue?macro=true";
import { default as indexIAI2culsHRWI1jA25PSN4BHy5K2bK3ZHJ4lMe5mwmCYMeta } from "/vercel/path1/app/pages/blog/index.vue?macro=true";
import { default as rechargingZZoufjZNzV5nQgetI83twBq9oMVTAZs3ZLBpjS4fh8MMeta } from "/vercel/path1/app/pages/recharging.vue?macro=true";
import { default as accessibilitySWma71yOrJWc2MfHU03kk0Qvt4OMQdHzdaPLBCHq0voMeta } from "/vercel/path1/app/pages/accessibility.vue?macro=true";
import { default as first_45postDd08m_oCMPdW8FUVz0GjUBA42rclSA8eCvWjy0G1YT0Meta } from "/vercel/path1/app/pages/blog/first-post.md?macro=true";
import { default as orgs5NKQVuCnr9mKrHQUyzivS_Z82sJoBllggJa5EcG8NlYMeta } from "/vercel/path1/app/pages/~[username]/orgs.vue?macro=true";
import { default as index4jkzWmxIy4vT_EjXVjAHok4q_UlPfuMEKSWG6xXG0a0Meta } from "/vercel/path1/app/pages/~[username]/index.vue?macro=true";
import { default as alpha_45releaseDkMbIlTAML1VL6SIPDisIlM0cASoEEaPPdvbw05ufusMeta } from "/vercel/path1/app/pages/blog/alpha-release.md?macro=true";
import { default as _91_46_46_46path_93yKNrM_pOBHM2Ttld5AuO8N5AvwebTswgW3h9seig1ccMeta } from "/vercel/path1/app/pages/package-docs/[...path].vue?macro=true";
import { default as indexCOmqdRGD6iJf_lza4UxmoCSW3AH6G_HlLNGUVqQfhCgMeta } from "/vercel/path1/app/pages/package/[[org]]/[name]/index.vue?macro=true";
import { default as _91version_93bg5w_blQQIeTuTN8kYGse2qe4UL1beUSpC3V33CLO3wMeta } from "/vercel/path1/app/pages/package/[[org]]/[name]/v/[version].vue?macro=true";
import { default as _91name_93BjAxByx8NPm5FgxIjcjWIdg5yhdyTYranfPAvzcGNQEMeta } from "/vercel/path1/app/pages/package/[[org]]/[name].vue?macro=true";
import { default as indexcx4NWWPWAR5BZScHxgc0hndLjnh6dp_DWe1f59Rmb2AMeta } from "/vercel/path1/app/pages/profile/[identity]/index.vue?macro=true";
import { default as _91versionRange_93GpxLMDtv7gbndKo5n4y9eut2Rs51I_9oBf8l4r2mSu0Meta } from "/vercel/path1/app/pages/diff/[[org]]/[packageName]/v/[versionRange].vue?macro=true";
import { default as _91_46_46_46filePath_93QLkxog6_qbeWGgffaKEnX2o7vwkPFlaK8ARpnzPBRmIMeta } from "/vercel/path1/app/pages/package-code/[[org]]/[packageName]/v/[version]/[...filePath].vue?macro=true";
export default [
  {
    name: "pds",
    path: "/pds",
    component: () => import("/vercel/path1/app/pages/pds.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path1/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path1/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/vercel/path1/app/pages/search.vue")
  },
  {
    name: "compare",
    path: "/compare",
    component: () => import("/vercel/path1/app/pages/compare.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path1/app/pages/privacy.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/vercel/path1/app/pages/settings.vue")
  },
  {
    name: "org",
    path: "/org/:org()",
    component: () => import("/vercel/path1/app/pages/org/[org].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path1/app/pages/blog/index.vue")
  },
  {
    name: "vacations",
    path: "/recharging",
    component: () => import("/vercel/path1/app/pages/recharging.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    component: () => import("/vercel/path1/app/pages/accessibility.vue")
  },
  {
    name: "blog-first-post",
    path: "/blog/first-post",
    component: () => import("/vercel/path1/app/pages/blog/first-post.md")
  },
  {
    name: "~username-orgs",
    path: "/~:username()/orgs",
    component: () => import("/vercel/path1/app/pages/~[username]/orgs.vue")
  },
  {
    name: "~username",
    path: "/~:username()",
    component: () => import("/vercel/path1/app/pages/~[username]/index.vue")
  },
  {
    name: "blog-alpha-release",
    path: "/blog/alpha-release",
    component: () => import("/vercel/path1/app/pages/blog/alpha-release.md")
  },
  {
    name: "docs",
    path: "/package-docs/:path+",
    meta: _91_46_46_46path_93yKNrM_pOBHM2Ttld5AuO8N5AvwebTswgW3h9seig1ccMeta || {},
    alias: ["/package/docs/:path+","/docs/:path+"],
    component: () => import("/vercel/path1/app/pages/package-docs/[...path].vue")
  },
  {
    name: _91name_93BjAxByx8NPm5FgxIjcjWIdg5yhdyTYranfPAvzcGNQEMeta?.name,
    path: "/package/:org?/:name()",
    component: () => import("/vercel/path1/app/pages/package/[[org]]/[name].vue"),
    children: [
  {
    name: "package",
    path: "",
    meta: indexCOmqdRGD6iJf_lza4UxmoCSW3AH6G_HlLNGUVqQfhCgMeta || {},
    component: () => import("/vercel/path1/app/pages/package/[[org]]/[name]/index.vue")
  },
  {
    name: "package-version",
    path: "v/:version()",
    component: () => import("/vercel/path1/app/pages/package/[[org]]/[name]/v/[version].vue")
  }
]
  },
  {
    name: "profile-identity",
    path: "/profile/:identity()",
    component: () => import("/vercel/path1/app/pages/profile/[identity]/index.vue")
  },
  {
    name: "diff",
    path: "/diff/:org?/:packageName/v/:versionRange",
    alias: ["/diff/:packageName/v/:versionRange"],
    component: () => import("/vercel/path1/app/pages/diff/[[org]]/[packageName]/v/[versionRange].vue")
  },
  {
    name: "code",
    path: "/package-code/:org?/:packageName/v/:version/:filePath(.*)?",
    meta: _91_46_46_46filePath_93QLkxog6_qbeWGgffaKEnX2o7vwkPFlaK8ARpnzPBRmIMeta || {},
    alias: ["/package/code/:org?/:packageName/v/:version/:filePath(.*)?","/package/code/:packageName/v/:version/:filePath(.*)?"],
    component: () => import("/vercel/path1/app/pages/package-code/[[org]]/[packageName]/v/[version]/[...filePath].vue")
  }
]